export default {
  askGoodPageData: {
    url: '/ec-pc-api/plan/askGoodPageData',
    type: 'post'
  },
  askGoodsSaveUpdate: {
    url: '/ec-pc-api/plan/askGoodsSaveUpdate',
    type: 'post'
  },
  delAskGood: {
    url: '/ec-pc-api/plan/delAskGood',
    type: 'get'
  },
  submit: {
    url: '/ec-pc-api/plan/submit',
    type: 'get'
  },
  // 要货计划
  queryGoodsDemandPlan: {
    url: '/ec-pc-api/plan/queryGoodsDemandPlan',
    type: 'post'
  },
  askGoodDetailsData: {
    url: '/ec-pc-api/plan/askGoodDetailsData',
    type: 'post'
  },
}